module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "weitgmechapter-2"
    }
  }, [_c('p', {
    staticClass: "chapter-number",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "chapter-head",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Run, Forest, Run!")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Around the spacious patio in front of Capitol Senior High’s cafeteria were concrete bench seats that students occupied during lunch period. They sat talking in small groups. Early arrivals claimed the shaded area under a few trees. Some worked on writing assignments or studied textbooks before their next class. On this particular day, Saint reclined on the patio steps, resting his head on his mesh book sack. He adjusted his authentic camouflage bush hat that a Vietnam-veteran friend, Hindu Spurlock, had given him. It covered his face, blocking the noonday sun. Next to Saint, in the same posture, was his longtime friend, Raymond Valentine. Raymond and Saint’s long legs were stretched over two platform steps, with their feet resting on the patio floor. The two had just come from smoking Kools in a recess near the door to the band department in front of the school. It was in the open but safer than smoking in the restroom, where coaches usually caught athlete smokers and punished them with extra practices.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#1.jpeg",
      "src": "Images/1.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Capitol High track team. Raymond Valentine is in the front row, far right. Saint is in the back row, center, wearing a wristband.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The Capitol Lions’ mile-relay track team had not lost a race all year. Saint, as the third leg, could run a 47.5-second quarter, bringing the baton to Raymond, who could finish the last 400-meter sprint in 48 seconds. The two teenagers had grown up together in Easy Town since 1965. Their mothers had been friends and were both deceased, a commonality the teens shared as brothers.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#2, page 17, Edna Bernitha Hammond.JPG",
      "src": "Images/2page17EdnaBern_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint’s mother, Edna, as a Red Cross nurse in the 1940s.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Nearly five years after the suicide, Saint still had questions lingering in his mind that he never got a chance to ask his mother as he was growing up.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who am I?")]), _vm._v(" "), _c('span', [_vm._v("he wondered")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(". How did I get here? Why am I here? Why do people die? Where will I go after I die? Who is God? How does He exist?")]), _vm._v(" "), _c('span', [_vm._v("Saint often asked himself these perplexing questions.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Do I not believe because God let my best friend in the world die? Why do I live on the edge of death?")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("In Zion City, it was a hot summer noonday in the mid-1960s. Eight-year-old Forest left the store carrying a brown paper grocery bag of bread, eggs, lemons, butter, and a pack of Salem cigarettes. Ignoring a voice in his conscience, he stopped at his favorite spot next to a little red church on Ford Street—the crawfish hole. Forest was barefoot, wearing cutoff jeans and no shirt. Sensing a creeping presence in a bushy area, he grabbed the grocery bag and took off running through the crawfish hole. John Henry exploded out of the bush, jumping over the hole in his track sneakers. Jesse James barely cleared it with his leap. Fat Bo-Bo jumped, landing in the middle of the puddle and getting stuck. As Forest followed a bending dirt trail through the woods, he grabbed a leaning branch. When John Henry saw the branch coming back, he ducked. Jesse James caught the branch in the face, flattening him to the ground. By the time Forest made it to the gravel road at Kissel Street a block and a half from home, John Henry was ten yards behind. Forest, covered with mud but still holding the grocery bag, ran across the hot thick bed of gravel. He prayed silently for help:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Good Lord, help me. Where you at?")]), _vm._v(" "), _c('span', [_vm._v("At the corner of Kissel and Packard, Forest turned at Bea’s Café. He ran through hedges and John Henry followed. Forest began zigzagging. John Henry zigzagged in close pursuit.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Where all the old people at?")]), _vm._v(" "), _c('span', [_vm._v("Forest wondered, since God hadn’t helped yet.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They usually be sitting on the porch. If they was sitting in they chairs and saw John Henry, they’d say, “Leave that boy alone! I’m a whip your a--, boy! Take your bad a-- home!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("As they ran past old wood-framed shotgun houses on the dusty dirt homestretch, it was quiet like a desert silence—with only the sounds of the rustling paper bag, bare feet slapping the dry ground, and grunts and deep breathing echoing each boy’s determination and refusal to give up. Then, something happened. Voices started talking to Forest again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stop running. He’s not behind you anymore. You’re just running for nothing. Stop! Turn around and see. Don’t be scared. Just turn. Aren’t you tired of running?")]), _vm._v(" "), _c('span', [_vm._v("one voice asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He’s behind you,")]), _vm._v(" "), _c('span', [_vm._v("warned the other.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No need to turn around. You don’t need to see. You hear him. Just know that he’s back there and keep running.")]), _vm._v(" "), _c('span', [_vm._v("Both voices sounded like his own.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("With his arm extended, John Henry reached, clawed, scratched, and grabbed with each step—his fingers slipping off Forest’s sweaty right shoulder as his prey stayed one step ahead. Forest jumped over a raised water meter. John Henry tripped over it and fell headfirst into an algae-filled ditch. Forest passed his younger brother Paul as he turned at the corner of the house and ran to the back and up the steps. He burst through the screen door, falling with the bag onto the floor. Lemons exploded out of the bag and scattered everywhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna was repeatedly striking the telephone receiver on the base. Just prior to her son’s dramatic entrance, she was serving lunch to her children when the phone rang. “Hello, Edna Bernitha speaking,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Is this the white half-breed b---- whose man I had last night? Half-breed, last night your man was hunting and shooting his two-legged coon,” a black woman’s voice uttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Now, Edna was gazing at her mud-covered, breathless son.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Mommy! John Henry and them was chasing after me. You shoulda seen me running! Boy, I was running so faaaast. You shoulda seen me, Mommy! He couldn’t catch me neither. He was breathing in my ears. I could hear him. His finger was scratching my shoulder. I wasn’t tired neither! I ain’t dropped your bag neither, Mommy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna took her mashed bread and egg-covered pack of Salems out of the bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I’m so proud of you, darling. We have an old Indian saying,” Edna said as she bandaged the soles of her son’s feet. “‘He that fights or runs away shall live to fight another day.’ Now, don’t forget that, you hear? Because you ran doesn’t mean you’re scared. A lot of people who didn’t run are in graveyards.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna was born on September 1, 1921, in Lawrenceville, Illinois. Her father, Elmer Hammond, was Jewish and her mother, Olivia Lyles, was Blackfoot Indian. Edna was raised on a farm and finished twelfth grade. She then moved to Los Angeles to study nursing and took a job with the Red Cross. In late 1949, she was sent to attend to injured veterans in Shreveport, where she met Forest Martin.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#3, PAGE 17, EDNA &amp; HER FATHER ELMER HAMMOND, 1940's.JPG",
      "src": "Images/3PAGE17EDNA_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Edna and her father on the Fourth of July 1948 in Lawrenceville.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#6, PAGE 17, EBH Dressed up!.JPG",
      "src": "Images/6PAGE17EBHDress_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Edna in 1948.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "car.JPG",
      "src": "Images/car_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Edna lived in Hollywood.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#5, PAGE 17, EBH HORSEBACK RIDING.JPG",
      "src": "Images/5PAGE17EBHHORSE_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Horseback riding in the Hollywood hills.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "floatGroup"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#8, PAGE 17, FOREST MARTIN, LATE 1940'S.JPG",
      "src": "Images/8PAGE17FORESTMA_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forest Martin in the 1940s in New Roads, Louisiana.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Martin was born on February 27, 1915, in Tolbert, Louisiana, about five miles south of New Roads. At the age of fourteen, he quit school and went to work on a log camp to help his mother take care of the family. He earned fifty cents a day. "), _c('span', [_vm._v("He became a hustler and streetwise businessman. When he met Edna, he owned a fleet of dump trucks in Baton Rouge and sold dirt to housing and commercial building contractors. The two moved in together. Fern Lorraine was first to be born to Edna and Forest, in 1951. Then Edna left Forest and lived in Indianapolis for over a year. When she returned, she did so with a second child, Vincent. Forest rejected Vincent, and Edna sent him to Los Angeles to live with her sister, Fern. In 1955, Forest Hammond was born, followed by his brother Paul in 1958. Their parents got married in 1959, and three more children were born: Teresa, Daisy, and Michael.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Forest was watching his mother as she tended to him. “Mommy, something told me not to go to that crawfish hole,” he admitted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“See, that’s the still small voice of your guardian angel, Yahweh Eloah, talking to you. If you listen and obey his voice, it’ll keep you out of trouble. I told you to go to the store and come straight back—not go to the crawfish hole. You didn’t listen; now look at your soles. You better start obeying what he tells you. One of these days, you’ll wish you had listened,” Edna admonished. She walked to the mantel and lit jar candles and incense. Above the mantel was a board with sketches of baby faces of her seven children. Normally she burned the candles and incense after she and her husband argued.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You saying another prayer for me? Who them people is on those candles?” Forest asked.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "AUNT FERN-EDNA'S SISTER, FERN, &amp; VINCENT.JPG",
      "src": "Images/AUNTFERN-EDNASSISTE_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forest, Aunt Fern, Fern Lorraine, and Vincent in 1956.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna pointed at the images painted on the jars and called their names. “St. Michael, St. Paul, St. Teresa, and St. Vincent. These are saints I named your brothers and sister after,” she answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("He searched the mantel in vain for his namesake candle jar. “Well, where St. Forest at, then?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna laughed and hugged her son. “You’re so crazy. You always make me laugh. There is no . . . Aw, you’re my special amazing Saint, just like your Amazing Spiderman.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The 1954")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brown vs. Board of Education")]), _vm._v(" "), _c('span', [_vm._v("desegregation decision by the United States Supreme Court was finally being implemented in Baton Rouge. The family moved from 5035 Packard Street to 3113 Newton Street in Easy Town. There Martin got out of the dirt-selling business and started a janitorial service. He bought a white van to haul his equipment in. Then the family moved to 205 North Twenty-Fifth Street, at the corner of Convention Street. Edna registered Saint at Westdale Junior High on Claycut Road. She convinced him to take certain courses, including music and French. Little did he know he would experience a side of life in this world he never knew existed—full-blown racism at the hands of white students and white teachers. In the hallway on the first day of school, as twelve-year-old Saint and other black students changed classes or went to their lockers, they heard, “Nigger, nigger, nigger,” “Look at that nigger,” “Darky,” “There’s goes another coon,” or “Look at that spook.” It was as if the white students were trying to make black students feel inferior for being black—as if anyone had a choice in the matter of what color they would be born.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#9, PAGE 18, 3113 NEWTON ST., EASYTOWN, 1965 -(L-R) FOREST, PAUL, TERESA, DAISY 1965.jpg",
      "src": "Images/9PAGE183113NEWT_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint, Paul, Teresa, and Daisy, Easter Sunday 1966. A Martin’s Janitorial van is visible behind them.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint’s last class that day was American history. His teacher was a Sergeant Carter lookalike. His name was Mr. Chambers. He had the traditional military haircut, khaki pants, a plaid shirt, and a loud, baritone voice. A yellow pencil stayed perched on one of his large ears. The class was held in a metal building on the backside of the main school building. Saint, the only black student in that class, claimed the last seat on the end row nearest the door. He wanted to be the first to run out when the bell sounded and the first on the school bus. After Mr. Chambers issued textbooks, he gave the first assignment to his class.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Learn the preamble to the United States Constitution and know it by heart tomorrow. You’re going to be graded on this assignment,” Chambers said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("That night, Edna had Saint recite the preamble over and over until he began complaining and making excuses. “Mommy, in all my classes, them white children know stuff I ain’t never heard of in all my life. They know what Mrs. Eubanks be talking about in math. I ain’t never heard none of them words before. Fractions! Them white students know everything she been talking about. They must have learned that in sixth grade wherever they went. I don’t know nothing, Mommy. Mr. Woods and Mr. White never taught us none of that stuff,” Saint said. “The preamble is too long. I can’t remember all of that.”")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#10, PAGE 19, SAINT @ 12 YRS OLD @ WESTDALE JUNIOR HIGH.JPG",
      "src": "Images/10PAGE19SAINT_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint’s school photo from Westdale Junior High, 1967.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You remembered the universe assignment from the encyclopedias I bought you all for Christmas in Zion City. You knew it by heart. You can remember this,” Edna replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The next day, after getting past wanting to fight any white student who called anybody “nigger,” Saint couldn’t wait to get to his American history class. He raised his hand each time Chambers asked, “Who wants to try it next?” Saint knew that the teacher had to see his only black arm in the class that was raised high—even lifting himself out of his seat to be recognized. Finally, when not one of the twenty-seven white students could recite the preamble without making mistakes, Chambers moved on to giving out assignments for the next day. This class had obviously come to an end.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Mr. Chambers!” Saint called.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The teacher looked around the class as though he couldn’t determine from which direction the voice came.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“It’s the nigger,” a white boy said. The class roared with laughter, but Chambers cut it short.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Now, stop that. We’re not going to have that in this class. Don’t say that,” Chambers instructed mildly. “Ah, yes, ah, Hammond, what is it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I know it. I want to say it—the preamble. I can say it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Ah, I didn’t get you? I didn’t see you back there. Ah, go ahead, Hammond. Stand,” Chambers, said looking in his roll book.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("When Saint stood, the entire class became silent.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“‘We the People of the United States, in order to form a more perfect union, establish justice, insure domestic tranquility, provide for the common defense, promote the general welfare, and secure the blessings of liberty to ourselves and our posterity, do ordain and establish this Constitution for the United States of America.’ Ah, that’s it. It’s just fifty-two words,” Saint added before sitting down.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Very good, Hammond. That’s a 100 percent grade for you. Well done,” Chambers said. Then he moved Saint’s desk to the first row, directly in front of his own desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("When Saint got home, he found Edna in the washroom and told her everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“That bastard!” she said. “He’s got me so mad I can chew arrowheads. He was just trying to show the white kids there was no need in calling on a Negro, because they can’t learn anything anyhow so why waste the time. I’m so proud of you, darling. You’re not as ignorant as they want you to be. One day you’re going to college and get a good education and be a lawyer like your grandpa. The more you know makes it hard for people to control you.” Edna gave her son a long hug.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna Bernitha was in tears in the same washroom on Saint’s last day of school. She stood reading her son’s final report card, which said:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RETAIN SEVENTH GRADE.")]), _vm._v(" "), _c('span', [_vm._v("“Lord, I’ve been a failure,” she cried, unable to look her son in the eyes. “The good Lord will make a way somehow. You’re going to a Negro school next year. These Southern hypocrite bastards.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint had never seen his mother so hurt. His father only made her angry. Seeing her children stripped of their dignity and made to believe they were stupid devastated her. The only classes Saint had passed were reading, music, and physical education.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Edna registered Saint at Valley Park Junior High in 1968.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("On the hot and muggy Friday night of October 4, 1968, Saint was awakened by the sound of the television two rooms away. The station had gone off the air but the volume was all the way up, so the static noise was very loud. Saint heard Vincent crying hysterically. “I’m sorry, Lord! Take me! Please don’t take her! When you made her you threw away the mold! You threw away the mold! You threw away the")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mold!”")]), _vm._v(" "), _c('span', [_vm._v("He was on his knees praying.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Vincent, what’s wrong?")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Why you crying?”")]), _vm._v(" "), _c('span', [_vm._v("Saint asked, almost shouting to be heard over the television. Vincent’s eyes remained closed. He didn’t acknowledge that he heard his brother. He seemed to search for words to penetrate some invisible realm where he could find help for the problem for which he was praying. Saint passed him and entered the living room/bedroom. Approaching the bed, he saw that Edna’s left arm hung lifelessly over the side. Her right arm was draped limply over her forehead. Her glassy eyes stared at the ceiling without blinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Mommy. What’s wrong? Why you looking like that?” Saint asked. He then saw it: a small bloodstain on Edna’s pink nightgown in the area of her heart. Next, he saw a piece of wood partially covered by the bedspread in the middle of the bed. He walked around to the foot and pulled the cover slightly back. It was the butt of his father’s hunting rifle. He pulled the cover further and saw the barrel lying on Edna’s chest in a puddle of blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Oh, no, Mommy! I love you! Why you did this? I love you, Mommy!” Saint cried frantically. He ran to Vincent. “Vincent! What happened? What happened? Mommy’s shot!” he shouted but got no response. Vincent continued his crying. Saint grabbed the keys to the old Chevy station wagon and ran through the back-porch screen door. Jumping over the four steps, he fell in the gravel in the back driveway. He got up quickly and started the Chevy. He didn’t know how to drive, but Baton Rouge General Hospital was a straight shot up Convention Street. He could keep the car in the middle of the road, he felt, and hit the brakes when necessary. Saint ran back inside and tried to get Vincent to help him lift Edna from the bed, carry her through the house, and place her in the car. She was too heavy for both of them. Vincent continued to pray with his eyes closed, tears running down his cheeks. He didn’t hear Saint or feel him jerking him. He appeared oblivious to the turmoil around him, almost as though he were in a trance. Saint turned the television off, ran to the phone, and dialed zero. It took forever for the zero to complete the full dial.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Operator! Send an ambulance to 205 North Twenty-Fifth Street. My mama’s shot! She’s bleeding all over the bed!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I’ve already done that!” Vincent yelled from the other room, apparently jolted back to reality. “The police and the ambulance are on the way!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Look at all these children in here,” a detective said after the ambulance had taken Edna to Baton Rouge General. As Saint sat on the green sofa with his hands rolled in his T-shirt, a detective stuck his head out the front door to speak to detectives on the porch. “What was the name of the doctor that pronounced the death?” he asked. Those were the cruelest words Saint had ever heard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Later, Saint’s father came home and stood beside the bloodstained mattress. He held his stomach with his bad right hand and covered his face with his left hand as he cried into it. White detectives surrounded him. They questioned Vincent about the location of others in the house. He had been the only one awake when Edna committed suicide. They were trying to determine how she could shoot herself with a long rifle.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("After Edna’s funeral, Vincent and Fern Lorraine moved to Los Angeles. Saint assumed the responsibility of rearing his youn")]), _c('span', [_vm._v("ger siblings.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("By the fall of 1969, Martin’s success with his janitorial business enabled him to buy a new house. Fairfields was an emerging black middle-class subdivision in Baton Rouge. Capitol Senior High was within walking distance. The house at 2929 Washington Avenue was a mansion compared to the other places they had lived, but without Edna’s presence, everyone, even Martin, felt a sense of emptiness. Because Saint was older than the others, his memories of the night Edna killed herself were vivid and longer lasting. His emptiness was deep.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#11, PAGE 24-Edna's funeral 20-13-29.JPG",
      "src": "Images/11PAGE24-Ednasfu_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Edna’s body lay at rest at Elm Grove Baptist Church, 1069 North Thirty-Eighth Street, October 6, 1968.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Martin’s business continued to grow. He hired employees. One spring day in 1971, when Saint and Paul came home from school, there was a 1963 red and white Ford station wagon parked at the curb in front of the house. It drove well, but it was ugly. It had no wide rear tires and no dual exhaust, and when Saint drove it, it felt as if he was steering a ship. He named it the fire wagon. Martin bought the car so Saint and Paul would have transportation to the offices they cleaned on weekdays and Saturdays.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "24, Oct 6th, 1968, DAY OF EDNA'S FUNERAL, VINCENT @ LEFT, SAINT WEARING TRACK MEDAL &amp; MICHAEL _SMOKIN JOE_ MARTIN.JPG",
      "src": "Images/24Oct6th1968DAY_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vincent, Saint wearing his Westdale Junior High track medal that made Edna proud, and Michael, in the living room the day of Edna’s funeral.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint and Paul had worked with Martin each day after school since 1965. Martin groused at his two sons about everything: “Use that hand scraper like I showed you! Scrape all the paint drops off them windows! Get down on your hands and knees and scrape all that old dead wax out them corners off the flo’! That’s too much water on the flo’!” Martin raised his voice about everything. “I said damp-mop the flo’, not soak it! What you trying to do, flood the damn building?” He drove his boys so hard on cleaning jobs that one thing was for certain: they would know how to work and do a job right the first time. By the end of summer workweeks, Saint’s and Paul’s arms were so sore and heavy and they were so tired that they would sleep all day on Sundays. The two boys worked and waxed so many buildings over the years that they were young professionals. The constant working in the cleaning business, vacuuming and using his arms, gave Saint fast hands that would serve him well one day.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#13, PAGE 25, AFTER EDNA'S DEATH FERN MOVED TO LOS ANGELES WITH VINCENT, 1969-70.JPG",
      "src": "Images/13PAGE25AFTERED_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fern Lorraine after moving to Los Angeles.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("For the long-awaited matchup between the Capitol Lions and McKinley Panthers basketball teams in the early spring of 1972, the Capitol High gym was packed. Spectators stood in the area behind each goal. Saint spotted a beautiful light-skinned girl, with long silky hair like his mother’s. He had never seen her at Capitol and figured she went to McKinley from the blue she wore. She entered the Lions’ side of the gym with an armful of drinks, popcorn, and hotdogs and searched the stands for her friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Right there! Right there!” Saint yelled. She saw him and looked in the direction he was pointing. She then saw his arm extended, but his index finger was curled back, pointing at himself. “You’re looking for me?” he yelled, smiling. When she gave him the most beautiful smile he’d ever seen, Saint stepped down, took the drinks out of her hand, helped her up, and gave her his spot, the last one available. He sat on the floor near the doorway and watched the game. Throughout the game they were caught watching each other. When the game was over, Saint waited until she exited and introduced himself. She told him her name was Daisy Marie Bessix. “For real?” he asked. “I got a sister and aunt named Daisy. Is it okay if I call you DMB, and can I call you tonight?” Saint asked, smiling. He got her phone number and called her later that night.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("East Baton Rouge Parish schools were dismissed early for those who wanted to attend the inauguration of the new Louisiana governor, Edwin W. Edwards, on the steps of the State Capitol. Saint picked DMB up in the fire wagon and together they attended the inauguration. Governor Edwards spoke English and French, thoroughly pleasing the crowd.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“On the campus of LSU, I have personally cooked, with my mama’s own Cajun recipe, tubs of shrimp, sausage, and chicken jambalaya! I have wagons pulled by horses all across the campus. I’m hungry. I hope you are! Everybody is invited to come eat. The food is good, and")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it’s free!”")]), _vm._v(" "), _c('span', [_vm._v("he yelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Once DMB located the wagon where Governor Edwards was serving, she and Saint got in line. She wanted the new governor to serve her. Saint was already eating with his head down when he bumped into DMB, knocking her into Edwards’ arms. Edwards caught her with one arm and held a bowl of jambalaya in the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Beautiful women just fall in my arms,” the governor said. The huge crowd around him laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Oh my goodness, Mr. Governor Edwards, I’m so sorry. I didn’t mean to. Good Lord, look at me,” DMB said shyly. “I’m so embarrassed.” The governor gave her a bowl of jambalaya and served Saint another bowl as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("On February 7, 1973, Saint accepted an offer of a full four-year football scholarship from Southern Illinois University at Carbondale. When head coach Dick Towers and Capitol High coach Roman Bates, Jr., visited him in his living room, Martin beamed with pride. “I never miss a game,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I’ve never seen anyone play football like he does, with the speed he has,” Coach Towers declared. “In one game on film, we counted nine fumbles he caused playing nose guard, and he’s just 168 pounds. He’s unbelievably fast. He almost got handoffs from the quarterback several games. He was offside twice for ten yards. I’ll take ten yards of penalties on any game day in return for nine fumble recoveries. Playing intercollegiate football, we’ll move him to running back.”")])]), _vm._v(" "), _c('div', {
    staticClass: "floatGroup"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "#14, PAGE 27, SAINT #82 TACKLES QB, 1972 FOOTBALL SEASON.jpg",
      "src": "Images/14PAGE27SAINT8_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint tackles East Ascension High quarter-back Guidry, at Memorial Stadium, Baton Rouge, 1972.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("“Forest is the best defensive end Capitol has ever had,” Coach Bates told Towers. “He never caused us any problems. He makes good grades. He’s disciplined and he respects all his teachers. I think he’s going to do real good at SIU, Coach.”")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I own Martin’s Personal Janitorial Service,” Martin chimed in. “He cleans eleven offices for me every night. He strips and waxes floors every Saturday, but I knew one day I was gonna lose him to some college. Coach Bates called me one day and told me colleges all over the nation was calling him about my boy. They can’t stop him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Saint signed and dated the letter of intent. He looked back at siblings Paul, Teresa, Daisy, and Michael standing in the hall door-way, sad at the prospect of his moving away.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("It was now less than two months before high-school graduation as Saint and Raymond lounged on the patio steps. Near the end of lunch period, Michael “Dike” Ingram and Curtis “Bones” Addison joined them. David, who sometimes worked with Saint for Martin, sat down too, along with Steve Ingram. Steve played left defensive end opposite Saint. Thanks to Saint giving Steve a good recommendation, Coach Towers awarded Steve a scholarship when Saint visited the SIU campus two weeks earlier. The four were dressed in their Army ROTC uniforms. After his first-hour ROTC class, Saint had gone home, changed out of his uniform, and returned wearing his favorite clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("When the bell rang ending the first half of the lunch period, everyone had a class to go to except Saint. He remained stretched out on the patio steps enjoying the sun, his hat still covering his face. Suddenly, someone kicked his feet. He looked up, shielding his face from the sun with his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Say, Forest Hammond, I got a proposition for you,” Alton “Boodie” Ramsey declared as he sat down beside him. Eighteen-year-old Boodie was second string on the football team, playing on special teams. He had just come to Capitol a year before, and his nickname was appropriate for his big butt. He only knew Saint from watching him at football and track practice; their relationship was merely casual.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Now, where did you hear that big word? I know you can’t spell it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I’m serious, man. Look, I heard you got some fireworks. If you let me borrow them for a week, I’ll make it worth your while. I’ll give you a thousand dollars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The streets were hazardous for young black males, and Saint had been shot at on occasion by street thugs, so he had purchased a 9mm and .38 for protection. He considered a teen named Skookie, who hung out in his Fairfields neighborhood, to be particularly dangerous. Saint wanted to be sure he had his “fireworks” if he attended any parties that spring.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I don’t know where you heard that at, but I don’t pop firecrackers no more. Besides, it’s against the law to pop them in the city limits,” Saint replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Man, I’m serious. Pee Wee hooked us up with a good job where we gonna make thousands,” Boodie continued. “I’ll give you two thousand dollars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The sound of the money was enticing, especially since Saint had a new girlfriend and his father wasn’t paying him a penny.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You know where I live?” Saint asked. After giving Boodie instructions for the pickup, Saint added, “You get ’em; they’re yours. You never got ’em from me. I don’t know nothing about ’em, you understand?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Okay, I got you covered,” Boodie said, then got up and walked away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Mrs. Stelly, a beautiful and fine white teacher, stood in the middle of Typing II with her stopwatch, timing the double classroom filled with students as they took their test. Saint’s fingers were flying. His hands were so strong and fast that, while the best students were typing 40 and 50 words per minute, he was producing 97. His goal was to reach 100.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Time. Hands off the home-row keys!”")]), _vm._v(" "), _c('span', [_vm._v("Mrs. Stelly shouted. All typing ceased except for the quick strikes coming from Saint’s typewriter. “That’ll cost you five words, Forest Hammond. You need to follow the rules,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Aaaah, Mrs. Stelly. I reached 100. Look!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“This isn’t Hollywood,” she said. “‘Stop’ means stop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The girls around Saint taunted him by pretending to brush lint off their shoulders. Saint often used the same gesture, to indicate a small thing that did not bother him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("As the class was leaving, a girl named Brenda begged, “Forest Hammond, please tell me you’ll come to my birthday party tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You sound desperate,” he answered, smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I know, but it’s just every football or basketball player I ask, they turn me down. I know it’s because of my brother and his friend Skookie. They know he’ll be there with his gang. I want somebody to come that everybody knows, and you and Chase are the most well known,” Brenda explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint looked at his watch and rushed off, ducking and dodging students. He turned back before running out of sight and called to Brenda, “I gotta go! I’ll be there—promise.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("That night, Baton Rouge police detectives Bob and Jimmy sat in their unmarked unit nearly a block away from Brenda’s house party, at the corner of Fairfields and Twenty-Eighth. Concealed by trees and shrubbery, they were staking out the party because confidential informants told them that drug dealers and those responsible for committing several armed robberies in the area would be there. Police were sure that Fairfields was the right place to look for suspects in the robberies.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Detective Jimmy read a")]), _vm._v(" "), _c('span', [_vm._v("nature magazine. “Did you know that a cockroach is the fastest-running creature on the planet earth, pound for pound? When threatened by danger it can run up to a hundred miles per hour. That’s amazing,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Watching through binoculars, Detective Bob saw several black teens on the porch, smoking what appeared to be marijuana. “No, I didn’t know that,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("At home, Michael followed Saint around as his older brother was getting dressed. Michael was seven years old. “I think I’m gonna get that kiss tonight,” Saint said, teasing Michael. “Granny is supposed to meet me over where I’m going.” Michael cringed.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "CHRIS COTTON, nephew, visiting Fern in L.A., Calif. January 1973.JPG",
      "src": "Images/CHRISCOTTONnephew_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint dressed for a weekend party.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Earlier that night, before cleaning the last office, Paul, David, and Michael sat in the fire wagon waiting for Saint while he visited DMB at her home. Her grandfather dozed in a rocking chair in the living room. A double-barrel shotgun leaned within arm’s reach against a chinaware cabinet. Grandpa was skinny, black as tar, and neatly dressed in a black suit and bowtie. He’d been a preacher years before. DMB’S mother was folding clothes. DMB sat at the dining-room table, doing homework. Grandpa’s wife, Big Mama, stood in front of her husband interrogating Saint, who was perched on a stool facing Grandpa. Big Mama had no teeth and chewed her tongue with her gums.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Do you work, boy? You got a job?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Ah, yes ma’am,” Saint answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You aren’t fooling ’round with them drugs, are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“No ma’am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Them drugs will kill you, boy, you know that? Let me see your hands,” she said, grabbing Saint’s hands as she looked at and felt the palms. “Yeah, you a worker. You can work in my garden and flowerbeds with theses hands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Through the French doors, Michael could see Big Mama questioning Saint as he sat on the stool, with her holding his hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Big Mama turned both of Saint’s hands over and saw shiny nail hardener on his fingernails. “Oooo, Lord Jesus, have mercy!” she yelled. Grandpa awoke, reaching for the shotgun out of reflex, but when he saw Saint, he stopped short of grabbing it. Saint looked at Grandpa, then at the shotgun, then at the door to his right. “Boy, tell me this isn’t fingernail gloss I’m looking at!” Big Mama screamed. “Boy, tell me. I needs to know! Are you a fruitcake? Huh? Are you? Are you a fruitcake? Tell me, boy, now!” Big Mama’s frown over her toothless gums formed an oval that looked like an abyss from where a command could come that would end Saint’s life.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Yes ma’am,” Saint answered. “I mean, no ma’am.” Daisy and her mother were nearly crying from laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Big Mama, Big Mama!” Daisy shouted. “That’s fingernail hardener. He’s a football player. He has to reach and grab football peoples. He wears that so his nails don’t break. He’s not a fruitcake, Big Mama. He’s a football player.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Later, as the fire wagon pulled away from DMB’s home, the right low-beam blew out as Michael began questioning Saint.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Hey, Saint.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Hey, Michael.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I want to ask you a question,” Michael said. “How Daisy look?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You been living with her all your life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I’m talking about your Daisy, DMB,” Michael said, laughing. “You know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint had been so busy cleaning offices since he met DMB that he had not brought her around the house yet. He had not even kissed her yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Oh, Daisy Marie Bessix. I call her DMB to not get her mixed up with Daisy and Aunt Daisy. Well, she’s about 101 years old. She’s old. She wears these knee-high brown stocking socks that’s rolled up. Her hair is silver and white. She got a whole lot of wrinkles all over her body. Even her eyeballs have wrinkles. She chews on her tongue with her gums because she doesn’t have any teeth, and, let me see, sometimes she chews tobacco, and ah, yeah, that’s about it. Oh, she wears an old white cap and a gown.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("With each detail described, Michael grimaced. “I think you better go back to Darlene or Joan, or Linda, or Shirley,” he advised. “It sounds like Daisy is an old granny. Well, I’m not going to ask if you, ah . . . ”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Kissed her yet?” Saint inquired quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Yeah,” Michael said, nodding, unsure if he wanted to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I wanted to, but she was too busy chewing her tongue. But she did grab both my hands and was holding and feeling them before I left. Old people like to feel hands first,” Saint explained. Michael had seen that and made another face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“But, but, why you choose to go with an old granny, Saint? I mean, she’s 101 years old! Isn’t she about to die?” Michael asked. David and Paul erupted with laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Well, we’re just going together right now. We aren’t getting married yet. I haven’t finished school.” Saint was biting his tongue to keep a straight face. Michael was leaning forward from the backseat with his chin resting on the middle of the front seat, studying his big brother. He struggled to understand his older brother’s decision to date an old lady and not the beautiful young girls he had previously seen him with.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Smokin’ Joe, look. You got to realize, she’s old-fashion, and them old-fashion peoples don’t kiss on the first date.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“You ain’t never lied,” David said, laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("At 9:30 that night, Saint was in the bathroom brushing his teeth. He put his bush hat on and admired himself in the mirror. Michael crept up on him, with his hands behind his back.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Saint, don’t look. Close your eyes and turn to me. I got a surprise for you,” Michael said. Saint complied.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Ooh! Michael! Why you did that?” Saint chased him around the living room, the kitchen twice, and caught him in his bedroom, throwing him on his bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I was trying to bust your lip so you couldn’t kiss old Granny tonight,” Michael said, laughing. He had his Smokin’ Joe kids’ boxing gloves on and had punched Saint in the mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“So you wanna play Smokin’ Joe, huh? Ali’s on the ropes; he throws Smokin’ Joe on the bed and tickles him. Smokin’ Joe laughs and laughs.” Saint quickly grabbed his leather jacket and ran out of the house. Michael got up, raced to the window, and tapped on it. He waved at Saint, who turned and waved back. Michael watched Saint’s hat, jacket, bleach-stained jeans, and white Converses go out of sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("As Saint neared the party, he could hear “It’s a Family Affair,” by Sly & and the Family Stone. Brenda’s porch was crowded with hoodlums. Skookie’s huge Afro made him easy to spot. Saint stepped onto Brenda’s lawn. B.C., a recently expelled student from Capitol, saw him. “Say, Skookie, look at that niggah Saint coming to the party. I ain’t never liked that niggah,” B.C. declared. Skookie stared at Saint. Buddy, Dent, Deadeye, Foots, and others were on the porch smoking joints.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Saint! Niggah, you ain’t invited to the party! Who told you to come?” Skookie shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Brenda, niggah! Who else? She’s in my typing class,” Saint answered after he drew closer. He made eye contact with everyone as he walked up to the steps. Skookie moved and stood blocking Saint from the porch. Saint reached the third step, then jumped, pivoting around a porch pillar. The door was opened by someone coming outside, and Saint slipped in.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Inside, psychedelic lights flashed and music blasted. The house was populated mostly by girls. A few guys were dancing, but Saint knew none of them. He found his way to the long food table set up across the open kitchen door. Saint got a party plate and piled it alternately with miniature meatballs, tuna bites, birthday cake, and mixed nuts. He washed it down with a glass of spiked punch. The next song was slow. Brenda stood on the dance floor with a huge smile, beckoning for Saint to dance. Saint was dancing with Brenda when Skookie came in with his friends and stood with their backs against the wall, staring. Skookie liked Brenda, but she only gave him the time of day because her brother Mike was his best friend. This was their first time meeting each other, but Saint knew Skookie was dangerous. Saint did a series of gorilla grinds, where his and Brenda’s bodies touched below the waist. It brought Skookie out.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Brenda, why you dancing with that ol’ punk-a—niggah?” he yelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("A new song started and Skookie began dancing with Brenda. Saint went back to the food table. Buddy, Dent, Deadeye, Foots, and B.C. surrounded Saint as he reached across the table for food. Saint pretended not to see the pistols in their waistbands, but seeing them caused him to feel a sudden need to be somewhere else. As Saint walked past Skookie and Brenda, Skookie grabbed Saint’s leather jacket sleeve, balling it in his fist and popping a button off as he jerked Saint back.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Niggah, why you bumped into my bush?” Skookie yelled. He stopped dancing. The thugs put their plates on the table and rushed up, flanking Saint. They stood watching him, but Saint knew he had not touched Skookie’s hair. That was the only way Skookie could stop him from leaving. Saint jerked his arm free.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Niggah, put your bush in your pocket,” he answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Put your pussy in your pocket, ol’ punk-a-- niggah!” Skookie shot back.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint stared at them all, then turned and continued through the crowd of dancers. The thugs went back to get their food about eight feet away. Skookie, however, never took his eyes off Saint and saw when he stopped, turned around, and came rushing back towards him with his fist balled. Skookie held his chin out, daring Saint to hit him. Saint hesitated, as if something told him not to punch him. He instead spread his open right hand over Skookie’s face and shoved him. The thrust sent him airborne—falling on the floor on his butt and sliding past B.C. B.C. saw two legs sticking out from under the table. He raised the tablecloth and Skookie sat looking up at him in shock. Blood oozed from his nose. The thugs turned around to see Saint standing and pointing at Skookie.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Get off your a-- and put that in your pocket, ol’ jive-a-- niggah,” Saint sneered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie opened the right side of his black leather jacket. When Saint saw the pearl handle of a pistol, he disappeared into the crowd.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie burst out the front door, screaming and wielding his .38 special. “Where that niggah Saint at? Which way did he go?” The porch crowd was too busy smoking marijuana and didn’t see Saint dart out and disappear across the street. “Who all got they s---?” Skookie asked. Each thug pulled out a gun. They searched the area around the house, looking like ants on a disturbed mound. “Buddy, show me where that niggah lives. We gonna go shoot that niggah’s house up. I don’t give a f--- who I kill inside. I’m ’a body bag somebody tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie led the pack towards Washington Avenue, two blocks away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Hearing the thugs as he squatted nearby behind huge leaves in an exotic flower garden, Saint feared for his siblings. “Damn. What have I got my family into now?” he whispered. Multiple thoughts darted through his mind as to what he should do, but mulling his options was taking too much time, so he simply took off running.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Roots from a giant oak tree made the broken sidewalk perilous for a runner at night. Saint took long, leaping strides into dark areas, knowing the hazards of landing on a piece of uneven pavement and snapping his ankle. Fate was on his side, however, and he ran faster.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Something’s definitely going down,” Detective Bob said to his partner, Jimmy. “Pull up a bit. I can’t see for all the trees. A gang of ’em just crossed the street.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Jimmy slowly nudged the brown Plymouth Fury forward. Bob held the binoculars to his eyes. The front tires crossed the sidewalk.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Keep going, a little more,” Bob said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“If I go any further, we’ll be going—")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aw, s----!”")]), _vm._v(" "), _c('span', [_vm._v("Jimmy shouted. “What was that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Damn!” Bob exclaimed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint leapt over the hood, never touching the car. Bob looked through the binoculars at the bush hat plastered back on the runner’s head under the streetlamp as he disappeared from sight. The runner never broke stride as he cut across the lawn of the house on the corner.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Jimmy sped into the street and to the corner of North Twenty-Sixth. The street was empty. He accelerated a block to Jackson Street and stopped. The officers looked both ways.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Which way did he go?” Jimmy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Through the binoculars, Bob saw the crowd a block away, passing through the intersection. “There goes our gang,” he said. “They’re in a hurry. Something’s up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("On the far side of Jackson Street, on the shadowy sidewalk, Saint was now running towards the gang. A Pontiac GTO two houses from the corner of North Twenty-Eighth Street blocked his path, forcing him to run out into Jackson Street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“There he is,” Bob said, peering through his binoculars.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I see him,” Jimmy confirmed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint arrived at the intersection, skipping laterally.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Skookieeee!”")]), _vm._v(" "), _c('span', [_vm._v("he screamed. The crowd stopped.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Nanny nanny pooh pooh—you can’t get me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Hold up. That’s my niggah!” Skookie shouted. He didn’t want anyone to shoot Saint except him. Saint began taunting and flipping them off until they came within sixty yards.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie shot at Saint, but he was gone. The bullets struck a stop sign as Saint passed it. Upon turning the corner, B.C. fired into the trees where he thought he might have been. Skookie fired once. Their bullets struck tree limbs and a metal chair on a porch and shattered a front window of a house. A woman screamed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Oh, s---! Gunfire! Get down there quick!”")]), _vm._v(" "), _c('span', [_vm._v("Bob barked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("The Plymouth Fury roared down the street with the lights still off. The bulk of the gang arrived at the corner as Jimmy slid sideways into the intersection. Both detectives got out with shotguns drawn. Bob fired a shot in the air and everyone suddenly realized it was an unmarked police unit. Three ran the opposite way, but the detectives held nearly a dozen at gunpoint.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Drop your godd--- guns!” Detective Bob shouted, as Jimmy called for backup.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie and B.C. followed behind Saint even though they didn’t see him. They jogged along opposite sides of the street. A pickup truck was parked by a huge tree on the corner. The house on the right stood five feet away, and smaller trees obstructed the view. Papa, Saint’s crippled neighbor, hobbled through the intersection going home towards Washington. B.C. and Skookie both aimed at him but quickly lowered their guns. “That’s Papa,” B.C. said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Suddenly, they realized it was Saint, now halfway through the intersection. He had put his hat and jacket under his left armpit and was limping like Papa.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“That’s that niggah!”")]), _vm._v(" "), _c('span', [_vm._v("B.C. yelled and started firing. Saint bolted as B.C. chased him, shooting as he ran. Bullets struck the truck’s driver’s-side door mirror and window and the rear window before his gun was emptied.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie aimed ahead of Saint, between the tree and house. His first shot hit the side window of a car parked on the side of North Thirtieth, just behind and to Saint’s left. The second shot extinguished a light on a house above Saint’s head. The third and fourth shots hit the edge of the corner house on Saint’s right as he leaned forward out of sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Drop your god--- weapons. I got a shotgun aimed at who don’t!” Detective Jimmy shouted. Skookie and B.C. turned slowly to see police-car lights turning in from Plank Road three blocks away. Both were arrested along with the others.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint hid for hours in the darkness outside his house, to be sure the coast was clear. Finally he sprinkled sand from a milk carton on the paved steps around the backdoor and climbed halfway into the house through his bedroom window. His right leg was hanging out the window when his father turned the light on.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“If you move, I’ll pop a cap in your a--,” Martin said, holding a gun in his left hand. Saint looked up, grinning at the gun, then pulled his leg in and stood up. “You gonna get your a-- shot climbing through my window this time of morning!” Martin bellowed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“What? You’re going kill me like you killed Mommy?” His words stunned Martin.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Boy, what’s wrong with you? You sound like you’ve been out there in them streets smoking that damn dope with them no good-a-- niggahs you hang out with. Go ahead and lie and say you wasn’t. What’s that, blood you getting on my curtains?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Skookie’s last bullets had broken the skin on the back of Saint’s neck, but the adrenaline surging through his body had left him oblivious to the wound. He looked at the curtain, felt the back of his neck, and saw blood on his fingerstips. “I wasn’t,” Saint protested.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Martin lowered his gun. “Your a-- needs to go to church, boy! Something’s wrong with you. I didn’t kill your mama! I loved Edna! That’s why I never got remarried. Why you say I killed your mama?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Go to church for what? You and all your women need to go to church. I’m talking about you and all your women killed her. She got tired of you spending money buying all your women jewelry and clothes and she didn’t have but three dresses she had to wear and wash out all the time! I remember. Mommy took care of you! You didn’t take care of her. You never gave her any money. You don’t even want to pay me and Paul for all the work we do! We need clothes and stuff. Everything in my closet I got by my own self—you know how?” Saint was mad now, so it didn’t matter. “I stole them! Like, shoplifting. What did you expect?” Saint asked, seeing Martin looking surprised. Tears began rolling down Martin’s face. He laid the gun on Saint’s bed, took his glasses off, and wiped his eyes with his undershirt. His sons had grown up and he had never realized it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint said, “Before I went to bed that night, Mommy was telling Aunt Daisy you was gone hunting two-legged coons, but then Vincent showed her that your hunting rifle was still in the closet. I didn’t know that on those nights you never killed any coons because you really didn’t go hunting. When she killed herself, you forgot your rifle and when you came home, you were all dressed up. I remember everything! All you want us for is to work like slaves for you. You didn’t even believe I would get a football scholarship, but I got one! I can’t wait to graduate next month, because I’m going to Southern Illinois.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Teresa, Daisy, and Michael had crept into the hall behind Martin. Only their heads could be seen as they peered around the doorframe. Paul had turned facing Saint, pretending to be asleep. His mouth moved, telling Saint to shut up for fear of his being shot.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Boy, you don’t even know what it is to be a man yet,” Martin said. “When I was fourteen, I was working on a log camp making fifty cents a day. I had to quit school and go to work. I tries to teach y’all the right way. I got a good name in this city. Everybody respects me. I can be a deputy sheriff if I want to. I got good credit. I can buy anything I want. Right is right, and wrong is wrong. When you’re right, you’re right, and when you’re wrong, you’re wrong. I am right, and you are wrong. Am I right?” Martin asked for the one-thousandth time.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“No, ya dig?” Saint replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“Listen at how you talk to me. Talk to me right! I don’t dig s---!” Martin roared. He took the pistol off the bed as if to shoot Saint but slapped him with his bad right hand instead. He’d shot himself when he was nineteen, trying to knock a rabbit out with the butt of his shotgun in order to save a shell. The shotgun discharged, shooting him in his right arm. He was on the side of the road when a white man picked him up and took him to the hospital. Instead of severing his right hand, doctors saved it as best they could, placing steel plates in it. His right hand was shaped like a claw. As he grew older, Martin was known to shoot dice with his left hand and rake the money in with his right claw. Many people feared him and gave him the nickname Iron Claw.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("“I don’t care what you don’t dig!” Saint said, holding the left side of his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Martin slowly turned and dragged himself towards his room. He heard Teresa, Daisy, and Michael bumping into furniture. Michael bounced off his door that had closed and fell on his butt. He got up, opened it, and dove into his bed. Martin’s thoughts were elsewhere. In the hall he stopped and came back, looking at Saint. He slowly raised his left hand and pointed his finger at Saint, as if casting a spell. “Boy, at the rate you going, you gonna be in penitentiary before you twenty years old. Mark my words.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Saint rolled his eyes as Martin turned, went to his room, and locked his door. Saint turned off the light and sat on the side of his bed. He reached under him, dug in his breadbox beneath the bed, and came out with half a fifth of wine. He took a long swallow and gasped and coughed as he stared in the dimness at the wall at newspaper clippings of his football heroics. He got a rubber band, twisted a paperclip, and shot it at one of his clippings. The paperclip tore the article and bounced off the wall. The face of his picture was ripped and hung down. Saint felt bad for talking to Martin that way, but he didn’t know how else to fight back.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79603d0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/WEITGMeCHAPTER2.vue
// module id = 87
// module chunks = 0